import { combineReducers, configureStore } from '@reduxjs/toolkit';
import reportsReducer from './slices/reportsSlice';
import productsReducer from './slices/productsSlice';
import reportsFilterReducer from './slices/reportsFiltersReducer';
import oneTimeJWTSliceReducer from './slices/onetTimeJWTSlice';
import navDropdownReducer from './slices/navDropdownSlice';
import boardingReducer from './slices/boardingSlice';
import singleProductReducer from './slices/singleProductSlice';
import stripePopUps from './slices/stripeSubscriptionPopUpSlice';
import buildApiService from './slices/buildApiSlice';
import { stripeApiSlice } from './slices/stripeApiSlice';
import { outletSlice } from './slices/outletSlice';
import {
  attributesApiSlice,
  categoriesApiSlice,
  productHistoryApiSlice,
  userApiSlice,
} from './slices';
import { ordersSlice } from './slices/ordersSlice';
import { mediaApiSlice } from '@/store/slices/mediaApiSlice';
import { taxTableSlice } from './slices/taxTableSlice';
import { organizationsSlice } from './slices/organizationsSlice';
import { companySlice } from './slices/companySlice';
import { dashboardApiSlice } from './slices/dashboardSlice';
import { plansApiSlice } from './slices/plansSlice';
import { featuresApiSlice } from './slices/featuresApiSlice';
import { extensionsApiSlice } from './slices/extensionsApiSlice';
import { checkOutFlowApiSlice } from './slices/checkOutFlowApiSlice';
import { pricingApiSlice } from './slices/pricingSlice';
import { pricingConfigurationApiSlice } from './slices/pricingConfigurationSlice';
import { orgApiKeysApiSlice } from './slices/orgApiKeySlice';

const rootReducer = combineReducers({
  [pricingApiSlice.reducerPath]: pricingApiSlice.reducer,
  [pricingConfigurationApiSlice.reducerPath]: pricingConfigurationApiSlice.reducer,
  [stripeApiSlice.reducerPath]: stripeApiSlice.reducer,
  [buildApiService.reducerPath]: buildApiService.reducer,
  [outletSlice.reducerPath]: outletSlice.reducer,
  [attributesApiSlice.reducerPath]: attributesApiSlice.reducer,
  [categoriesApiSlice.reducerPath]: categoriesApiSlice.reducer,
  [userApiSlice.reducerPath]: userApiSlice.reducer,
  [productHistoryApiSlice.reducerPath]: productHistoryApiSlice.reducer,
  [ordersSlice.reducerPath]: ordersSlice.reducer,
  [mediaApiSlice.reducerPath]: mediaApiSlice.reducer,
  [taxTableSlice.reducerPath]: taxTableSlice.reducer,
  [organizationsSlice.reducerPath]: organizationsSlice.reducer,
  [companySlice.reducerPath]: companySlice.reducer,
  [dashboardApiSlice.reducerPath]: dashboardApiSlice.reducer,
  [plansApiSlice.reducerPath]: plansApiSlice.reducer,
  [featuresApiSlice.reducerPath]: featuresApiSlice.reducer,
  [extensionsApiSlice.reducerPath]: extensionsApiSlice.reducer,
  [checkOutFlowApiSlice.reducerPath]: checkOutFlowApiSlice.reducer,
  [orgApiKeysApiSlice.reducerPath]: orgApiKeysApiSlice.reducer,
  reports: reportsReducer,
  reportsFilters: reportsFilterReducer,
  products: productsReducer,
  stripeSubscriptionPopUp: stripePopUps,
  oneTimeJWT: oneTimeJWTSliceReducer,
  navDropdown: navDropdownReducer,
  boarding: boardingReducer,
  singleProduct: singleProductReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      buildApiService.middleware,
      stripeApiSlice.middleware,
      outletSlice.middleware,
      attributesApiSlice.middleware,
      categoriesApiSlice.middleware,
      userApiSlice.middleware,
      productHistoryApiSlice.middleware,
      ordersSlice.middleware,
      mediaApiSlice.middleware,
      taxTableSlice.middleware,
      organizationsSlice.middleware,
      companySlice.middleware,
      dashboardApiSlice.middleware,
      plansApiSlice.middleware,
      featuresApiSlice.middleware,
      extensionsApiSlice.middleware,
      checkOutFlowApiSlice.middleware,
      pricingApiSlice.middleware,
      pricingConfigurationApiSlice.middleware,
      orgApiKeysApiSlice.middleware,
    ),
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
